import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar/Navbar'
import Hero from './components/Hero/Hero'
import About from './components/About/About'
import Gallery from './components/Gallery/Gallery'
import Activities from './components/Activities/Activities'
import Pricing from './components/Pricing/Pricing'
import Equipment from './components/Equipment/Equipment'
import Contact from './components/Contact/Contact'
import Occupancy from './components/Occupancy/Occupancy'
import Footer from './components/Footer/Footer'
import SEO from './components/SEO/SEO'
import './App.css'
function App() {
  return (
    <Router>
      <SEO />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <Footer />
              </>
            } />
            <Route path="/galerie" element={
              <>
                <Gallery />
                <Footer />
              </>
            } />
            <Route path="/aktivity" element={
              <>
                <Activities />
                <Footer />
              </>
            } />
            <Route path="/cenik" element={
              <>
                <Pricing />
                <Footer />
              </>
            } />
            <Route path="/obsazenost" element={
              <>
                <Occupancy />
                <Footer />
              </>
            } />
            <Route path="/vybaveni" element={
              <>
                <Equipment />
                <Footer />
              </>
            } />
            <Route path="/kontakt" element={
              <>
                <Contact />
                <Footer />
              </>
            } />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

export default App
